import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  FormLabel,
  Grid,
  LinearProgress,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import {
  BasicMenuItem,
  BasicSelect,
} from "../../ReuseComponents/Select/BasicSelect";
import {
  CancelButton,
  ContainedButton,
} from "../../ReuseComponents/Button/BasicButton";
import Controller from "../../../Controller/ApiController";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import { OutlinedTextField } from "../../ReuseComponents/TextField/BasicTextField";
import validationRegExp from "../../../Configuration/ValidationConfig";
import { Alert } from "../../ReuseComponents/Alert/Alertmessage";
import QRIVRBookingPopup from "../../ReuseComponents/Popup/QRIVRBookingPopup";
import UtilDateTime from "../../../Constant/utillDateTime";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
import QGLogo from "../../../Assets/qgliderlogo.png";
import InfoIcon from "../../../Assets/icons/infoIcon.svg";
import KEY_ID from "../../../Configuration/RazorpayConfig";



export default function CheckInStatusPage() {

  const { appointment_uid } = useParams();
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [currentToken, setCurrentToken] = useState("");
  const [awayToken, setAwayToken] = useState(0);
  const [clinicName, setClinicName] = useState("");
  const [errorMassage, setErrorMassage] = useState("");
  
   const getApiData =  async () => {
    let res = await Controller.ApiController(
      "GET",
      `/check_in_appointment/${appointment_uid}`,
      "",);
     
        // console.log(res,"resDataNew")
        if (res.type === "success") {
          setCurrentToken(res?.data?.token);
          setAwayToken(res?.data?.away_token_count);
          setClinicName(res?.data?.hospital_or_clinic_name);
        } else {         
          // Alert("error", res.error.message);
          setErrorMassage(res.error.message)
        }      
   }

   useEffect(() => {
    getApiData();
   },[])

  return (
    <Box sx={{ width: "100%" }} display={"flex"} justifyContent={"center"}>
     
   <Box
        sx={{
          backgroundColor: "#fff",
          padding: { xs: "20px", sm: "30px" },
          borderRadius: "10px",
          textAlign: "center",
          width: { xs: "320px", sm: "400px" },
        }}
      >
        <Box
          component={"img"}
          src={QGLogo}
          sx={{
            width: { xs: "159px", md: "256px" },
            height: { xs: "69px", md: "91px" },
            mb: 4,
          }}
        />
        <Typography
          fontSize={"25px"}
          mb={3}
          fontFamily={"Poppins"}
          color={"#000"}
          fontWeight={700}
        >
          Welcome to {clinicName}
        </Typography>
        <Grid item xs={12} mt={3} mb={3}>
  <Box
    sx={{
      border: "2px solid #41BA8F",
      borderRadius: "6px",
      // backgroundColor: "#e6f0fa",
      width: errorMassage ? "auto" : "200px",
      textAlign: "center",
      mx: "auto",
      boxShadow: "2px 2px 10px rgba(0,0,0,0.1)"
    }}
  >
    <Box
      sx={{
        backgroundColor: "#41BA8F",
        color: "#ffffff",
        padding: "8px 0",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: "16px"
      }}
    >
      Current Token Number
    </Box>
            <Box sx={{ padding: "16px" }}>
              {currentToken && <Typography
                fontSize="35px"
                fontFamily="Poppins"
                fontWeight={700}
              // color="red"
              >
                {currentToken}
                {awayToken > 0 && (
                  <>
                    <br />
                    <Typography
                      fontSize="10px"
                      fontFamily="Poppins"
                      fontWeight={400}
                    >
                      {awayToken === 1 ? (
                        <>Next your appointment</>
                      ) : (
                        <>You are <span style={{ color: "#22B175", fontWeight: 600 }}>{awayToken}</span> Token away</>
                      )}
                    </Typography>
                  </>
                )}
                {awayToken == '-1' && (
                  <>
                    <br />
                    <Typography
                      fontSize="10px"
                      fontFamily="Poppins"
                      fontWeight={400}
                    >
                      You are Currently Checked In
                    </Typography>
                  </>
                )}
              </Typography>}

              {errorMassage &&
                <Typography
                  fontSize="35px"
                  fontFamily="Poppins"
                  fontWeight={700}
                // color="red"
                >
                  {errorMassage}
                </Typography>
              }
            </Box>
  </Box>
</Grid>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 100000 }}
        open={loaderOpen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
    </Box>
  );
}
